define('components/sidemenu/views/SideMenuView', [
    'components/sidemenu/templates/sidemenuview'
], function(tpl) {

    var SideMenuView = Mazarine.View.extend({

        events: {
            "click .maz-toggle-burger": "onBurgerClick",
            "click .maz-side-menu-overlay": "onClickOverlay",
            "touchstart .maz-side-menu-overlay": "onClickOverlay"
        },

        template: tpl,
        className: "maz-side-menu-container",

        /*
         * This function render the side menu and his content.
         * More options can be found on the SideMenuModel.js
         */
        render: function() {
            this.$el.html(this.template(this.model.toJSON()));
            this.$el.addClass("maz-side-menu-" + this.model.get('position'));
            $(this.model.get('attach')).append(this.$el);

            if (this.model.get('view')) {
                this.$('.maz-side-menu-wrapper').prepend(this.model.get('view').render().$el);
            }

            $('html').addClass('maz-side-menu-opened');

            if (_.isFunction(this.model.get('view').afterRender)) {
                this.model.get('view').afterRender();
            }

            this.delegateEvents();
        },

        /*
         * This funciton handle the burger click by toggling the view.
         */
        onBurgerClick: function(e) {
            if( e )
                e.preventDefault();

            this.toggleMenu();
        },

        /*
         * This function handle the overlay click by closing the menu
         */
        onClickOverlay: function(e) {
            if( e )
                e.preventDefault();

            this.closeMenu();
        },

        /*
         * This function open/close the sidemenu according to his current state
         */
        toggleMenu: function(){
            if (this.model.get('opened')) {
                this.closeMenu();
            } else {
                this.openMenu();
            }
        },

        /*
         * This function open the menu by adding class (open in css)
         */
        openMenu: function() {
            this.model.set('opened', true);
            // TweenLite.to(this.$('.maz-side-menu-container'), 0.3, { 'left': 0 });
            this.$el.addClass("maz-side-menu-open");

            var openCallback = this.model.get('openCallback');

            if (openCallback) {
                openCallback();
            }
        },

        /*
         * This function close the menu by removing class
         */
        closeMenu: function() {
            this.model.set('opened', false);
            // TweenLite.to(this.$('.maz-side-menu-container'), 0.3, { 'left': "-" + this.$('.maz-side-menu-wrapper').width() });
            this.$el.removeClass("maz-side-menu-open");

            var closeCallback = this.model.get('closeCallback');

            if (closeCallback) {
                closeCallback();
            }
        }

    });


    return SideMenuView;
});
